import { render, staticRenderFns } from "./detailCryptoTransaction.vue?vue&type=template&id=5ff6a946&scoped=true"
import script from "./detailCryptoTransaction.vue?vue&type=script&lang=js"
export * from "./detailCryptoTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff6a946",
  null
  
)

export default component.exports